<div class="app-header">
    <a routerLink="/c">
        <img alt="Rose logo" src="assets/logo.png" class="logo header-logo" appBusy>
    </a>
</div>
